import React, { useState } from "react";
import styles from "./TestimonialsGridView.module.css";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import Button from "@mui/material/Button";
import { useEffect } from "react";
import { Avatar } from "@mui/material";


function TestimonialsGridView(props) {
const {
  testimonials
} = props 

const [cardData, setCardData] = useState([])

useEffect(() => {
  console.log("hohoho", testimonials)
  if(testimonials?.length > 0){
    let tempData = testimonials?.map((singleTestimonial)  => {
      let country_name = ""
      if(singleTestimonial?.user_country != ""){
        country_name = singleTestimonial?.user_country
      }else{
        if(singleTestimonial?.user_address_object != ""){
          const placeData = JSON.parse(singleTestimonial?.user_address_object);

          // 2. Check if the parsed data has the expected structure
          if (placeData && placeData.value && placeData.value.terms) {
            const termsArray = placeData.value.terms;
            
            // 3. Get the last term (the country)
            const countryTerm = termsArray[termsArray.length - 1];
            country_name = countryTerm.value
          }
        }
      
        
      }

      return {
        img : singleTestimonial?.user_avatar,
        name : singleTestimonial?.user_name,
        country : country_name,
        message : singleTestimonial?.feedback
      }
    })

    setCardData(tempData)
  }
}, [testimonials])


  return (
    <div className={styles.MainSection}>
      <div className={styles.Container}>
      <div className={styles.Title}>Testimonials</div>
        <div className={styles.ContentContainer}>
          
          {cardData.map((item, i) => (
          <div className={styles.Card}>
            <div className={styles.CardInner}>
              <div className={styles.CardHeader}>
                <div className={styles.Avatar}>
                  {/* <img
                    className={styles.Imge}
                    src={item?.img}
                  /> */}
                  <Avatar
                    key={i}
                    sx={{ width: 50, height: 50 }}
                    src={item?.img ? item?.img : ""}
                  >
                    {item?.img ? "" : item?.name ? item?.name[0]?.toUpperCase() : ""}
                  </Avatar>
                
                </div>
                <div className={styles.Details}>
                  <div className={styles.Name}>{item?.name}</div>
                  <div className={styles.Designation}>{item?.country}</div>
                </div>
              </div>

              <div className={styles.Message}>
                {item?.message}
              </div>
            </div>
          </div>
          ))}
        </div>
        {/* <div className={styles.ViewMoreButtonContainer}>
        <Button className={styles.ViewMoreButton} variant="text">View 2.1K+ more reviews</Button>
        </div> */}
      </div>
    </div>
  );
}

export default TestimonialsGridView;
